
import dangNhapService from "./dangnhap.service"
import dangXuatService from "./dangxuat.service"
import taiKhoanService from "./taikhoan.service"
import quyenTruyCapService from "./quyentruycap.service"
import quyenTruyCapAdminService from "./quyentruycap.admin.service"
import donViService from "./donvi.service"
import nhanVienService from "./nhanvien.service"
import nhanVienPersonalService from "./nhanvien.personal.service"
import hopDongService from "./hopdong.service"
import hopDongPersonalService from "./hopdong.personal.service"
import dichVuService from "./dichvu.service"
import khachHangService from "./khachhang.service"
import khachHangPersonalService from "./khachhang.personal.service"
import donViHanhChinhService from "./donvihanhchinh.service"
import dashBoardDefaultService from "./dashbord.default.service"
import phieuKhaoSatService from "./phieukhaosat.service"
import thongKeService from "./thongke.service"
import thongKePersonalService from "./thongke.personal.service"
import lichSuThaoTacService from "./lichsutruycap.service"
import TrungTamService from "./trungtam.service"
import PublicService from "./public.service"
import getCookie from "../utils/getCookie"
function getDangNhapService() {return dangNhapService}
function getDangXuatService() {return dangXuatService}
function getTaiKhoanService() {return taiKhoanService}
function getQuyenTruyCapService() {return quyenTruyCapService}
function getQuyenTruyCapAdminService() {return quyenTruyCapAdminService}
function getDonViService() {return donViService}
function getNhanVienService() {return nhanVienService}
function getNhanVienPersonalService() {return nhanVienPersonalService}
function getHopDongService() {return hopDongService}
function getHopDongPersonalService() {return hopDongPersonalService}
function getDichVuService() {return dichVuService}
function getKhachHangService() {return khachHangService}
function getKhachHangPersonalService() {return khachHangPersonalService}
function getDonViHanhChinhService() {return donViHanhChinhService}
function getDashBoardDefaultService() {return dashBoardDefaultService}
function getThongKeService() {return thongKeService}
function getThongKePersonalService() {return thongKePersonalService}
function getPhieuKhaoSatService() {return phieuKhaoSatService}
function getLichSuThaoTacService() {return lichSuThaoTacService}
function getTrungTamService() {return TrungTamService}
function getPublicService() {return PublicService}
function getAjaxConfig() {return {
    method: "GET",
    headers: {
        "Authorization": getCookie("tk")
    },
    body: null,
}}
function getAjaxConfigPOST(fillter) {return {
    method: "POST",
    headers: {
        "Content-Type": "application/json",
        "Authorization": getCookie("tk")
    },

    body: JSON.stringify(fillter),
}}
const Services = {
    getPublicService,
    getTrungTamService,
    getDangNhapService,
    getDangXuatService,
    getTaiKhoanService,
    getQuyenTruyCapService,
    getQuyenTruyCapAdminService,
    getDonViService,
    getDonViHanhChinhService,
    getNhanVienService,
    getNhanVienPersonalService,
    getHopDongService,
    getDichVuService,
    getKhachHangService,
    getHopDongPersonalService,
    getKhachHangPersonalService,
    getDonViHanhChinhService,
    getDashBoardDefaultService,
    getPhieuKhaoSatService,
    getThongKeService,
    getThongKePersonalService,
    getLichSuThaoTacService,
    getAjaxConfig,
    getAjaxConfigPOST
   
}

export default Services